import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetSelfServiceFlowHighlightedArticles} from '../hooks/useGetSelfServiceFlow';
import {HighlightedArticlesView} from './HighlightedArticlesView';

export const HighlightedArticles = ({smallTitle}: {smallTitle?: boolean}) => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowHighlightedArticles()}
      View={HighlightedArticlesView}
      viewProps={{smallTitle}}
      Error={() => null}
      Loading={() => null}
    />
  );
};
